<template>
  <div class="chats">
    <div
      v-for="(message, index) in messages"
      :key="message.ref"
      class="chat"
      :class="{ 'chat-left': isNotOwnerMessage(message) }"
    >
      <div v-if="message.type == 'text' || isMediaOrFile(message)">
        <div class="chat-avatar" v-if="isNotOwnerMessage(message)">
          <b-avatar
            v-if="message.sender.avatar"
            size="36"
            class="avatar-border-2 box-shadow-1 btn-chat-avatar"
            variant="primary"
            :src="`${message.sender.avatar}?width=35`"
            button
            @click="openProfile(message)"
          >
          </b-avatar>
          <div v-else class="cursor-pointer" @click="openProfile(message)">
            <b-avatar
              size="36"
              class="customer-profile"
              variant="light-primary"
            >
              <feather-icon icon="UserIcon" size="22" />
            </b-avatar>
          </div>
        </div>
        <div class="chat-body">
          <div>
            <!-- delete msg -->
            <!-- <div v-if="message.participant.id == userData.id" class="message-action">
              <b-dropdown variant="link" no-caret toggle-class="p-0" left>
                <template #button-content>
                  <feather-icon icon="MoreVerticalIcon" size="17" class="align-middle text-body" />
                </template>
              <b-dropdown-item @click="confirmDelete(message.id)">
                {{ $t("button.delete") }}
              </b-dropdown-item>
              </b-dropdown>
              </div> -->
            <!-- end delete msg -->
            <div class="chat-group-content">
              <div
                class="chat-content chat-bubble-box-shadow"
                :class="{
                  'p-0': message.type == 'media',
                  matched: activeRoom.lastMessage
                    ? activeRoom.lastMessage.createdAt == message.createdAt
                      ? true
                      : false
                    : false,
                }"
                :style="[
                  isVideo(getFileUrl(message)) ? { background: 'none' } : {},
                ]"
                @click="
                  isImage(getFileUrl(message))
                    ? viewImage(message)
                    : isDoc(getFileUrl(message))
                    ? openFile(getFileUrl(message))
                    : () => {}
                "
              >
                <div class="d-flex justify-content-between">
                  <div
                    class="message-content d-flex align-items-center w-100"
                    :class="`${
                      isMediaOrFile(message) && !isVideo(getFileUrl(message))
                        ? 'chat-image-chat-private'
                        : ''
                    } ${isMediaOrFile(message) ? `cursor-pointer` : ``}`"
                  >
                    <div
                      v-if="isMediaOrFile(message)"
                      class="message-attachment"
                      :style="[
                        isVideo(getFileUrl(message))
                          ? { marginBottom: '-5px' }
                          : {},
                      ]"
                    >
                      <img
                        v-if="isImage(getFileUrl(message))"
                        :src="getFileUrl(message)"
                        class="cursor-pointer rounded"
                        :style="{
                          width: '10rem',
                          height: 'auto',
                          maxHeight: 'unset',
                          paddingLeft: 0,
                          paddingRight: 0,
                        }"
                      />

                      <!-- <p class="pre-formatted">{{ message.message }}</p> -->
                      <video
                        v-else-if="isVideo(getFileUrl(message))"
                        class="rounded"
                        :style="{ width: '100%', maxWidth: '180px' }"
                        controls
                      >
                        <source
                          :src="
                            getFileUrl(message) ||
                            createObjectURL(getFileUrl(message))
                          "
                        />
                        Your browser does not support HTML5 video.
                      </video>

                      <div
                        v-else-if="isDoc(getFileUrl(message))"
                        class="p-1"
                        :style="{ position: 'relative' }"
                        :class="{
                          fillSvgBlack:
                            message.sender.merchantUserId != userData.id,
                        }"
                      >
                        <file-icon :style="{color: 'gray'}" />
                        <span class="file-ext" :style="{ color: 'white' }">
                          {{ getFileExtDisplay(getFileName(message)) }}
                        </span>
                        <!-- <CsvIcon v-if="isCsv(getFileUrl(message))" />
                        <PdfIcon v-else-if="isPdf(getFileUrl(message))" />
                        <ExcellIcon v-else-if="isExcel(getFileUrl(message))" />
                        <MsWordIcon v-else-if="isWord(getFileUrl(message))" /> -->
                      </div>

                      <div v-else-if="isAudio(getFileUrl(message))">
                        <div class="wave-voice">
                          <WaveSurferVoice
                            :key="message.mediaUrl"
                            :url="message.mediaUrl"
                            icon-inner-color="white"
                            icon-outer-color="#8d5185"
                          />
                        </div>
                      </div>
                    </div>

                    <p
                      v-if="
                        !isVideo(getFileUrl(message)) &&
                        !isAudio(getFileUrl(message)) &&
                        !isImage(getFileUrl(message))
                      "
                      class="pre-formatted w-100 float-left"
                      style="word-break: break-word"
                    >
                      {{ message.message }}
                    </p>
                  </div>
                </div>

                <div
                  v-if="
                    message.type == isMediaOrFile(message) &&
                    message.uploadPercentage &&
                    message.uploadPercentage < 100 &&
                    message.sentStatus == messageStatus.sending
                  "
                  class="text-center rounded"
                  :style="{
                    position: 'relative',
                    backgroundColor: '#bbb',
                    fontSize: '10px',
                    height: '1rem',
                    marginTop: !isDoc(getFileUrl(message)) ? '0px' : '.5rem',
                  }"
                >
                  <div
                    class="loading rounded"
                    :style="{
                      width: `${message.uploadPercentage}%`,
                      height: '1rem',
                      position: 'absolute',
                      left: '-1px',
                      backgroundColor: isVideo(getFileUrl(message))
                        ? '#8d5185'
                        : '#ac88b3',
                    }"
                  />
                  <span :style="{ position: 'relative' }">
                    {{ message.uploadPercentage }}%
                  </span>
                </div>
              </div>

              <div
                v-if="message.status == 'reject'"
                class="fail-icon cursor-pointer"
              >
                <feather-icon
                  v-b-tooltip.hover
                  :title="$t('action.canNotSendBankOrPhoneInfo')"
                  icon="AlertCircleIcon"
                  class="cursor-pointer text-danger"
                  size="22"
                />
              </div>

              <div
                v-if="message.sentStatus == messageStatus.fail"
                class="fail-icon"
                :class="{
                  'cursor-pointer': activeRoom.state == conversationStatus.open,
                }"
                @click="retrySendMessage(index)"
              >
                <feather-icon
                  icon="AlertCircleIcon"
                  class="cursor-pointer text-danger"
                  size="22"
                />
              </div>
            </div>
          </div>
          <small class="chat-content chat-time">
            <span
              v-if="message.sentStatus == messageStatus.fail"
              class="text-danger"
            >
              {{ $t("chat.fail") }}
            </span>
            <span v-else-if="message.sentStatus == messageStatus.sending">
              {{ $t("chat.sending") }}
            </span>
            <span v-else>
              <span v-if="message.isSeen">
                {{ $t("chat.seen") }}
              </span>
              {{ message.createdAt | formatShortDate }}
            </span>
          </small>
        </div>
      </div>

      <div
        v-else-if="
          message.type == 'activity' && message.message != 'activity.group.join'
        "
        class="chat-information"
      >
        <div v-if="message.message == 'activity.group.left'" class="badge-chat">
          <span>
            {{ $t("action.leftGroup", { operator: message.sender.name }) }}
          </span>
        </div>

        <div
          v-else-if="message.message == 'activity.operator.invite'"
          class="badge-chat"
        >
          <span>
            {{
              $t("chat.inviteOperator", { inviterName: message.sender.name })
            }}
          </span>
        </div>

        <div
          v-else-if="message.message == 'activity.group.create'"
          class="badge-chat"
        >
          <span>
            {{
              $t("chat.createTheGroup", { creatorName: message.sender.name })
            }}
          </span>
        </div>

        <div
          v-else-if="message.message == 'activity.operator.unavailable'"
          class="badge-chat"
        >
          <span>
            {{ $t("action.operatorUnavailable") }}
          </span>
        </div>
        <div
          v-else-if="
            message.message == 'order_placed_auto' ||
            message.message == 'Order_placed_auto'
          "
          class="badge-chat"
        >
          <span>
            {{ $t("chat.orderPlacedAuto", { orderName: message.sender.name }) }}
          </span>
        </div>
        <div
          v-else-if="
            message.message == 'order_placed_manual' ||
            message.message == 'Order_placed_manual'
          "
          class="badge-chat"
        >
          <span>
            {{
              $t("chat.orderPlacedManual", { orderName: message.sender.name })
            }}
          </span>
        </div>
        <div
          v-else-if="
            message.message == 'order_accept' ||
            message.message == 'Order_accept'
          "
          class="badge-chat"
        >
          <span>
            {{ $t("chat.orderAccept", { orderName: message.sender.name }) }}
          </span>
        </div>
        <div
          v-else-if="
            message.message == 'order_cancelled' ||
            message.message == 'Order_cancelled'
          "
          class="badge-chat"
        >
          <span>
            {{ $t("chat.orderCancelled", { orderName: message.sender.name }) }}
          </span>
        </div>
        <div
          v-else-if="
            message.message == 'order_timeout' ||
            message.message == 'Order_timeout'
          "
          class="badge-chat"
        >
          <span>
            {{ $t("chat.orderTimeout", { orderName: message.sender.name }) }}
          </span>
        </div>
        <div
          v-else-if="
            message.message == 'order_paid' || message.message == 'Order_paid'
          "
          class="badge-chat"
        >
          <span>
            {{ $t("chat.orderPaid", { orderName: message.sender.name }) }}
          </span>
        </div>
        <div
          v-else-if="
            message.message == 'receipt_rejected' ||
            message.message == 'Receipt_rejected'
          "
          class="badge-chat"
        >
          <span>
            {{
              $t("chat.receiptRejected", { receiptName: message.sender.name })
            }}
          </span>
        </div>
        <div
          v-else-if="
            message.message == 'receipt_confirmed' ||
            message.message == 'Receipt_confirmed'
          "
          class="badge-chat"
        >
          <span>
            {{
              $t("chat.receiptConfirmed", { receiptName: message.sender.name })
            }}
          </span>
        </div>
        <div
          v-else-if="
            message.message == 'order_suspended' ||
            message.message == 'Order_suspended'
          "
          class="badge-chat"
        >
          <span>
            {{ $t("chat.orderSuspended", { orderName: message.sender.name }) }}
          </span>
        </div>
        <div
          v-else-if="
            message.message == 'order_completed' ||
            message.message == 'Order_completed'
          "
          class="badge-chat"
        >
          <span>
            {{ $t("chat.orderCompleted", { orderName: message.sender.name }) }}
          </span>
        </div>
        <div v-else class="badge-chat">
          {{ $t(message.message) }}
        </div>
        <div class="text-center">
          <small
            v-if="index == 0 && message.message == 'activity.group.create'"
          >
            {{ message.createdAt | formatDate }}
          </small>
          <small v-else>{{ message.createdAt | formatShortDate }}</small>
        </div>
      </div>

      <div
        v-if="
          message.type == 'activity' && message.message == 'activity.group.join'
        "
        class="user-profile"
        :style="{
          height:
            message && message.sender && message.sender.avatar
              ? `140px`
              : `auto`,
        }"
      >
        <img
          v-if="message && message.sender && message.sender.avatar"
          :src="`${message.sender.avatar}?width=150`"
          class="img-fluid rounded-circle"
          alt="Avatar"
          :style="{
            'object-fit': 'cover',
          }"
        />
        <p v-if="message && message.sender && message.sender.name">
          <span class="text-primary">{{ message.sender.name }}</span>
          {{ $t("chat.joined") }}
        </p>
        <small>
          {{ message.createdAt | formatShortDate }}
        </small>
      </div>
    </div>
    <div v-if="isTyping">
      <div
        v-for="({ avatar }, index) in userTyping.typing"
        :key="index"
        class="chat chat-left"
      >
        <div class="chat-message">
          <div class="chat-avatar">
            <b-avatar
              v-if="avatar"
              size="36"
              class="avatar-border-2 box-shadow-1 btn-chat-avatar"
              variant="primary"
              :src="`${avatar}?width=35`"
            >
            </b-avatar>
            <b-avatar
              v-else
              size="36"
              class="avatar-border-2 box-shadow-1 btn-chat-avatar"
              variant="light-primary"
            >
              <feather-icon icon="UserIcon" size="22" />
            </b-avatar>
          </div>
          <div class="chat-body">
            <div class="chat-content chat-bubble-box-shadow">
              <div class="typing">
                <div class="dot" />
                <div class="dot" />
                <div class="dot" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <image-preview :image="image" @close="image = ''" />
  </div>
</template>

<script>
import {
  BAvatar,
  BButton,
  BDropdown,
  BDropdownItem,
  BTooltip,
} from "bootstrap-vue";
import messageStatus from "@/data/messageStatus";
import messageType from "@/data/messageType";
import conversationStatus from "@/data/conversationStatus";
import languageEn from "@/data/languages/en";
import CsvIcon from "@/components/icons/CsvIcon.vue";
import FileIcon from "@/components/icons/FileIcon.vue";
import ExcellIcon from "@/components/icons/ExcellIcon.vue";
import MsWordIcon from "@/components/icons/MsWordIcon.vue";
import PdfIcon from "@/components/icons/PdfIcon.vue";
import { getCountryByLanguageCode } from "@/libs/helper";
import localeCountries from "@/data/localeCountries";
import useJwt from "@/auth/jwt/useJwt";
import Repository from "@/repositories/RepositoryFactory";
import WaveSurferVoice from "@/components/WaveSurferVoice.vue";
import {
  isVideo,
  isDoc,
  isImage,
  isCsv,
  isExcel,
  isPdf,
  isWord,
  isAudio,
  getFileExtDisplay,
} from "../../helpers/fileHelper";
import ImagePreview from "./ImagePreview.vue";

const TranslateRepository = Repository.get("translateRepository");
const ChatMessageRepository = Repository.get("chatMessage");

export default {
  components: {
    BAvatar,
    ImagePreview,
    BButton,
    BDropdown,
    BDropdownItem,

    CsvIcon,
    ExcellIcon,
    MsWordIcon,
    PdfIcon,
    WaveSurferVoice,
    BTooltip,
    FileIcon,
  },
  props: {
    activeRoom: {
      type: Object,
      default: () => ({}),
    },
    messages: {
      type: Array,
      default: () => [],
    },
    readMessage: {
      type: String,
      default: "",
    },
    userTyping: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      image: "",

      messageStatus,
      messageType,
      conversationStatus,
      loading: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },

    isTyping() {
      return (
        this.userTyping?.typing?.length >= 1 &&
        this.userTyping?.room?._id == this.activeRoom.roomId
      );
    },
  },
  methods: {
    openProfile(message) {
      document.documentElement.style.setProperty("--avatar-outline", "#8d5185");
      if (message?.sender?.merchantUserId) {
        this.$emit("open-profile", message?.sender?.merchantUserId);
      }
    },
    isMediaOrFile(message) {
      return message.type == "media" || message.type == "file";
    },
    isNotOwnerMessage(message) {
      return message?.sender?.merchantUserId != this.userData.id;
    },
    confirmDelete(messageId) {
      this.$bvModal
        .msgBoxConfirm(this.$t("alert.deleteThisMessage"), {
          title: this.$t("alert.areYouSure"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("button.delete"),
          cancelTitle: this.$t("button.cancel"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteMessage(messageId);
          }
        });
    },
    deleteMessage(messageId) {
      ChatMessageRepository.delete(messageId)
        .then((response) => {})
        .then((error) => {
          this.isModalOpen = false;
        });
    },
    systemTranslatedMessage(message) {
      return message?.chatSettings?.translatedMessage;
    },
    systemDetectedLanguage(message) {
      return message?.chatSettings?.detectedLanguage;
    },
    systemTranslatedLanguage(message) {
      return message?.chatSettings?.translatedLanguage;
    },
    actionTransfer() {
      if (this.activeRoom?.transferredFrom) {
        return this.$t("action.transferringFrom");
      }
      return this.$t("action.transferringTo");
    },

    mapTransferMerchantName(createdAt) {
      if (this.activeRoom?.transferredFrom) {
        return this.activeRoom.transferredFromName || "N/A";
      }
      if (this.activeRoom?.transferred) {
        const transferring = this.activeRoom.transferred.find(
          (e) =>
            e.startedAt <= createdAt && (!e.endedAt || createdAt <= e.endedAt)
        );
        if (transferring) {
          return transferring?.toName || "NO NAME";
        }
      }
      return "N/A";
    },
    getCountryCode(language) {
      return this.localeCountries.find(
        (e) => e.language.toLowerCase() === language?.toLowerCase()
      )?.flag;
    },
    isTranslate() {
      return (
        this.activeRoom.isAutoTranslate ||
        JSON.parse(localStorage.getItem("chatSettings")).isTranslationOn == 1
      );
    },
    getEmoji(target) {
      if (target == null) {
        return;
      }
      const data = this.getCountryByLanguageCode(this.languageEn, target);
      return data?.emoji;
    },
    createObjectURL(file) {
      return window.URL.createObjectURL(file);
    },
    openFile(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
    getFileUrl(message) {
      if (!message?.attachments?.length) return;
      return message?.attachments[0]?.url;
    },
    viewImage(message) {
      if (!message?.attachments?.length) return;
      const image = message?.attachments[0]?.url;
      if (image) {
        this.image = image;
      }
    },
    retrySendMessage(index) {
      this.$emit("retry", index);
    },
    onTranslate(index) {
      // this.$emit("translate", index);
      this.loading = true;
      const message = this.messages[index];
      const target = this.$i18n.locale;
      TranslateRepository.translate({ text: message.message, target })
        .then((response) => {
          this.messages[index].translatedMessage =
            response?.data?.data?.translatedMessage;
          this.messages[index].translatedLanguage =
            response?.data?.data?.translatedLanguage;
          this.messages[index].detectedLanguage =
            response?.data?.data?.detectedLanguage;
          this.chatBoxKey += 1;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  setup() {
    return {
      getCountryByLanguageCode,
      languageEn,
      localeCountries,
      isImage,
      isVideo,
      isDoc,
      isCsv,
      isExcel,
      isPdf,
      isWord,
      isAudio,
      getFileExtDisplay,
    };
  },
};
</script>

<style scoped>
.wave-voice {
  width: 100%;
  height: 100%;
  padding: 0.5rem 1rem 0.5rem 0;
}

.chat.chat-left .chat-group-content {
  flex-direction: row-reverse;
  gap: 10px;
}

.btn.btn-chat-avatar:focus {
  outline: var(--avatar-outline) solid 3px;
}
</style>
